import { useEffect } from "react";
import { connect } from "react-redux";

import { hubConstants } from "../../constants/global.constants";
import { setItemToStorage } from "../../system/storage";
import { loginActions } from "../../redux/actions";

const importSurveyCss = async () => {
  await import("../../assets/css/components/sidebar/sidebar.css");
};

const importHubCss = async () => {
  await import("../../assets/css/hub.css");
  await import("../../assets/css/components/sidebar/hubSidebar.css");
  await import("../../assets/css/consumerResponses/hubConsumerResponses.css");
};

// Remember whether the app runs inside Hub or on its own, and load matching styles.
const AppModeInitializer = (props) => {
  const { hubRootElement, hubImagePathElement, setFromHub } = props;

  useEffect(() => {
    if (hubRootElement && hubImagePathElement) {
      setFromHub({
        isActive: true,
        value: hubRootElement.value,
        imagePath: hubImagePathElement.value,
      });
      importHubCss();
      setItemToStorage(hubConstants.FROM_HUB_KEY, hubConstants.FROM_HUB_VALUE);
    } else {
      setItemToStorage(
        hubConstants.FROM_HUB_KEY,
        hubConstants.FROM_SURVEY_VALUE
      );
      importSurveyCss();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hubRootElement, hubImagePathElement]);

  return null;
};

const mapDispatchToProps = (dispatch) => ({
  setFromHub: (data) => dispatch(loginActions.setFromHub(data)),
});

export default connect(null, mapDispatchToProps)(AppModeInitializer);
